import img_0 from "./images/img_0.png";
import img_1 from "./images/img_1.png";
import img_2 from "./images/img_2.png";
import img_3 from "./images/img_3.png";
import img_4 from "./images/img_4.png";
import img_5 from "./images/img_5.png";
import img_6 from "./images/img_6.png";
import img_7 from "./images/img_7.png";
import img_8 from "./images/img_8.png";
import img_9 from "./images/img_9.png";
import img_10 from "./images/img_10.png";
import img_11 from "./images/img_11.png";
import img_12 from "./images/img_12.png";
import img_13 from "./images/img_13.png";

const data = {
	v: "5.6.2",
	fr: 25,
	ip: 0,
	op: 112,
	w: 1080,
	h: 1080,
	nm: "FIXEL LOGO ANI_V03",
	ddd: 0,
	assets: [
		{ id: "image_0", w: 848, h: 272, u: "", p: img_0, e: 0 },
		{ id: "image_1", w: 848, h: 272, u: "", p: img_1, e: 0 },
		{ id: "image_2", w: 848, h: 272, u: "", p: img_2, e: 0 },
		{ id: "image_3", w: 848, h: 272, u: "", p: img_3, e: 0 },
		{ id: "image_4", w: 848, h: 272, u: "", p: img_4, e: 0 },
		{ id: "image_5", w: 848, h: 272, u: "", p: img_5, e: 0 },
		{ id: "image_6", w: 848, h: 272, u: "", p: img_6, e: 0 },
		{ id: "image_7", w: 848, h: 272, u: "", p: img_7, e: 0 },
		{ id: "image_8", w: 848, h: 272, u: "", p: img_8, e: 0 },
		{ id: "image_9", w: 848, h: 272, u: "", p: img_9, e: 0 },
		{ id: "image_10", w: 848, h: 272, u: "", p: img_10, e: 0 },
		{ id: "image_11", w: 848, h: 272, u: "", p: img_11, e: 0 },
		{ id: "image_12", w: 848, h: 272, u: "", p: img_12, e: 0 },
		{ id: "image_13", w: 848, h: 272, u: "", p: img_13, e: 0 },
		{
			id: "comp_0",
			layers: [
				{
					ddd: 0,
					ind: 1,
					ty: 2,
					nm: "Layer 3",
					parent: 5,
					refId: "image_0",
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: {
							a: 1,
							k: [
								{ i: { x: 0, y: 1 }, o: { x: 0.333, y: 0 }, t: 92, s: [287.638, -56, 0], to: [-44.94, 0, 0], ti: [44.94, 0, 0] },
								{ i: { x: 0, y: 0 }, o: { x: 0.167, y: 0.167 }, t: 103, s: [18, -56, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0, y: 1 }, o: { x: 0.167, y: 0 }, t: 138, s: [18, -56, 0], to: [64.333, 0, 0], ti: [-64.333, 0, 0] },
								{ t: 150, s: [404, -56, 0] }
							],
							ix: 2
						},
						a: { a: 0, k: [424, 136, 0], ix: 1 },
						s: { a: 0, k: [100, 100, 100], ix: 6 }
					},
					ao: 0,
					ip: 61,
					op: 151,
					st: 61,
					bm: 0
				},
				{
					ddd: 0,
					ind: 2,
					ty: 2,
					nm: "Layer 6",
					parent: 5,
					refId: "image_1",
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: {
							a: 1,
							k: [
								{ i: { x: 0, y: 1 }, o: { x: 0.333, y: 0 }, t: 94, s: [287.638, -56, 0], to: [-44.94, 0, 0], ti: [44.94, 0, 0] },
								{ i: { x: 0, y: 0 }, o: { x: 0.167, y: 0.167 }, t: 105, s: [18, -56, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0, y: 1 }, o: { x: 0.167, y: 0 }, t: 136, s: [18, -56, 0], to: [64.333, 0, 0], ti: [-64.333, 0, 0] },
								{ t: 148, s: [404, -56, 0] }
							],
							ix: 2
						},
						a: { a: 0, k: [424, 136, 0], ix: 1 },
						s: { a: 0, k: [100, 100, 100], ix: 6 }
					},
					ao: 0,
					ip: 63,
					op: 151,
					st: 63,
					bm: 0
				},
				{
					ddd: 0,
					ind: 3,
					ty: 2,
					nm: "Layer 4",
					parent: 5,
					refId: "image_2",
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: {
							a: 1,
							k: [
								{ i: { x: 0, y: 1 }, o: { x: 0.333, y: 0 }, t: 96, s: [287.638, -56, 0], to: [-44.94, 0, 0], ti: [44.94, 0, 0] },
								{ i: { x: 0, y: 0 }, o: { x: 0.167, y: 0.167 }, t: 107, s: [18, -56, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0, y: 1 }, o: { x: 0.167, y: 0 }, t: 134, s: [18, -56, 0], to: [64.333, 0, 0], ti: [-64.333, 0, 0] },
								{ t: 146, s: [404, -56, 0] }
							],
							ix: 2
						},
						a: { a: 0, k: [424, 136, 0], ix: 1 },
						s: { a: 0, k: [100, 100, 100], ix: 6 }
					},
					ao: 0,
					ip: 65,
					op: 151,
					st: 65,
					bm: 0
				},
				{
					ddd: 0,
					ind: 4,
					ty: 2,
					nm: "Layer 5",
					parent: 5,
					refId: "image_3",
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: {
							a: 1,
							k: [
								{ i: { x: 0, y: 1 }, o: { x: 0.333, y: 0 }, t: 98, s: [287.638, -56, 0], to: [-44.94, 0, 0], ti: [44.94, 0, 0] },
								{ i: { x: 0, y: 0 }, o: { x: 0.167, y: 0.167 }, t: 105, s: [18, -56, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0, y: 1 }, o: { x: 0.167, y: 0 }, t: 131, s: [18, -56, 0], to: [64.333, 0, 0], ti: [-64.333, 0, 0] },
								{ t: 143, s: [404, -56, 0] }
							],
							ix: 2
						},
						a: { a: 0, k: [424, 136, 0], ix: 1 },
						s: { a: 0, k: [100, 100, 100], ix: 6 }
					},
					ao: 0,
					ip: 67,
					op: 151,
					st: 67,
					bm: 0
				},
				{
					ddd: 0,
					ind: 5,
					ty: 3,
					nm: "Null 2",
					sr: 1,
					ks: {
						o: { a: 0, k: 0, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: {
							a: 1,
							k: [
								{ i: { x: 0, y: 1 }, o: { x: 1, y: 0 }, t: 89, s: [2159, 1215.9, 0], to: [-195.167, -13.833, 0], ti: [195.167, 13.833, 0] },
								{ i: { x: 0, y: 0 }, o: { x: 0.167, y: 0.167 }, t: 104, s: [988, 1132.9, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0, y: 1 }, o: { x: 1, y: 0 }, t: 131, s: [988, 1132.9, 0], to: [195.167, 13.833, 0], ti: [-195.167, -13.833, 0] },
								{ t: 146, s: [2159, 1215.9, 0] }
							],
							ix: 2
						},
						a: { a: 0, k: [0, 0, 0], ix: 1 },
						s: {
							a: 1,
							k: [
								{ i: { x: [0, 0, 0.667], y: [1, 1, 1] }, o: { x: [1, 1, 0.333], y: [0, 0, 0] }, t: 89, s: [346.8, 346.8, 100] },
								{ i: { x: [0, 0, 0.667], y: [1, 1, 1] }, o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] }, t: 104, s: [193.8, 193.8, 100] },
								{ i: { x: [0, 0, 0.667], y: [1, 1, 1] }, o: { x: [1, 1, 0.333], y: [0, 0, 0] }, t: 131, s: [193.8, 193.8, 100] },
								{ t: 146, s: [346.8, 346.8, 100] }
							],
							ix: 6
						}
					},
					ao: 0,
					ip: 0,
					op: 151,
					st: 0,
					bm: 0
				},
				{
					ddd: 0,
					ind: 6,
					ty: 2,
					nm: "Layer 2",
					parent: 5,
					refId: "image_4",
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: {
							a: 1,
							k: [
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 8.26, s: [18, -56, 0], to: [0, -9.333, 0], ti: [0, 9.333, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 10.866, s: [18, -112, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 16.081, s: [18, -112, 0], to: [0, -9.3, 0], ti: [0, 9.3, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 18.688, s: [18, -167.8, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 26.512, s: [18, -167.8, 0], to: [0, -9.333, 0], ti: [0, 9.333, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 29.118, s: [18, -223.8, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 34.334, s: [18, -223.8, 0], to: [0, -9.333, 0], ti: [0, 9.333, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 36.94, s: [18, -279.8, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 42.155, s: [18, -279.8, 0], to: [9.367, 0, 0], ti: [-9.367, 0, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 44.763, s: [74.2, -279.8, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 49.978, s: [74.2, -279.8, 0], to: [9.333, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 52.586, s: [130.2, -279.8, 0], to: [0, 0, 0], ti: [0, -9.35, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 55.192, s: [130.2, -223.7, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 60.407, s: [130.2, -223.7, 0], to: [0, 9.317, 0], ti: [0, -9.317, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 63.015, s: [130.2, -167.8, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 68.229, s: [130.2, -167.8, 0], to: [0, 9.3, 0], ti: [0, -9.3, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 70.837, s: [130.2, -112, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 76.052, s: [130.2, -112, 0], to: [0, 9.35, 0], ti: [0, -9.35, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 78.659, s: [130.2, -55.9, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 81.267, s: [130.2, -55.9, 0], to: [-9.4, 0, 0], ti: [9.4, 0, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 83.874, s: [73.8, -55.9, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 86.481, s: [73.8, -55.9, 0], to: [-9.267, 0, 0], ti: [9.267, 0, 0] },
								{ t: 89.0888671875, s: [18.2, -55.9, 0] }
							],
							ix: 2
						},
						a: { a: 0, k: [424, 136, 0], ix: 1 },
						s: { a: 0, k: [100, 100, 100], ix: 6 }
					},
					ao: 0,
					ip: 0,
					op: 151,
					st: 11,
					bm: 0
				},
				{
					ddd: 0,
					ind: 7,
					ty: 2,
					nm: "Layer 14",
					parent: 5,
					refId: "image_5",
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: {
							a: 1,
							k: [
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 8.26, s: [18, -56, 0], to: [0, -9.333, 0], ti: [0, 9.333, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 10.866, s: [18, -112, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 16.081, s: [18, -112, 0], to: [0, -9.3, 0], ti: [0, 9.3, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 18.688, s: [18, -167.8, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 26.512, s: [18, -167.8, 0], to: [0, -9.333, 0], ti: [0, 9.333, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 29.118, s: [18, -223.8, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 31.726, s: [18, -223.8, 0], to: [9.35, 0, 0], ti: [-9.35, 0, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 34.334, s: [74.1, -223.8, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 42.155, s: [74.1, -223.8, 0], to: [9.367, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 44.763, s: [130.3, -223.8, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 47.37, s: [130.3, -223.8, 0], to: [0, 0, 0], ti: [0, -9.317, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 49.978, s: [130.3, -167.9, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 52.586, s: [130.3, -167.9, 0], to: [0, 9.35, 0], ti: [0, -9.35, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 55.192, s: [130.3, -111.8, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 60.407, s: [130.3, -111.8, 0], to: [0, 9.317, 0], ti: [0, -9.317, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 63.015, s: [130.3, -55.9, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 68.229, s: [130.3, -55.9, 0], to: [0, 9.3, 0], ti: [0, -9.3, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 70.837, s: [130.3, -0.1, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 73.444, s: [130.3, -0.1, 0], to: [-9.317, 0, 0], ti: [9.317, 0, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 76.052, s: [74.4, -0.1, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 81.267, s: [74.4, -0.1, 0], to: [-9.4, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 83.874, s: [18, -0.1, 0], to: [0, 0, 0], ti: [0, 9.317, 0] },
								{ t: 86.4814453125, s: [18, -56, 0] }
							],
							ix: 2
						},
						a: { a: 0, k: [424, 136, 0], ix: 1 },
						s: { a: 0, k: [100, 100, 100], ix: 6 }
					},
					ao: 0,
					ip: 0,
					op: 151,
					st: 11,
					bm: 0
				},
				{
					ddd: 0,
					ind: 8,
					ty: 2,
					nm: "Layer 11",
					parent: 5,
					refId: "image_6",
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: {
							a: 1,
							k: [
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 8.26, s: [18, -56, 0], to: [0, -9.333, 0], ti: [0, 9.333, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 10.866, s: [18, -112, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 16.081, s: [18, -112, 0], to: [0, -9.3, 0], ti: [0, 9.3, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 18.688, s: [18, -167.8, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 23.903, s: [18, -167.8, 0], to: [9.3, 0, 0], ti: [-9.3, 0, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 26.512, s: [73.8, -167.8, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 31.726, s: [73.8, -167.8, 0], to: [9.35, 0, 0], ti: [-9.35, 0, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 34.334, s: [129.9, -167.8, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 39.549, s: [129.9, -167.8, 0], to: [0, 9.317, 0], ti: [0, -9.317, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 42.155, s: [129.9, -111.9, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 47.37, s: [129.9, -111.9, 0], to: [0, 9.317, 0], ti: [0, -9.317, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 49.978, s: [129.9, -56, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 52.586, s: [129.9, -56, 0], to: [0, 9.35, 0], ti: [0, -9.35, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 55.192, s: [129.9, 0.1, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 60.407, s: [129.9, 0.1, 0], to: [0, 9.317, 0], ti: [0, -9.317, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 63.015, s: [129.9, 56, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 65.622, s: [129.9, 56, 0], to: [-9.3, 0, 0], ti: [9.3, 0, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 68.229, s: [74.1, 56, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 73.444, s: [74.1, 56, 0], to: [-9.317, 0, 0], ti: [9.317, 0, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 76.052, s: [18.2, 56, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 78.659, s: [18.2, 56, 0], to: [0, -9.35, 0], ti: [0, 9.35, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 81.267, s: [18.2, -0.1, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 83.874, s: [18.2, -0.1, 0], to: [0, -9.317, 0], ti: [0, 9.317, 0] },
								{ t: 86.4814453125, s: [18.2, -56, 0] }
							],
							ix: 2
						},
						a: { a: 0, k: [424, 136, 0], ix: 1 },
						s: { a: 0, k: [100, 100, 100], ix: 6 }
					},
					ao: 0,
					ip: 0,
					op: 151,
					st: 9,
					bm: 0
				},
				{
					ddd: 0,
					ind: 9,
					ty: 2,
					nm: "Layer 10",
					parent: 5,
					refId: "image_7",
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: {
							a: 1,
							k: [
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 8.26, s: [18, -56, 0], to: [0, -9.333, 0], ti: [0, 9.333, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 10.866, s: [18, -112, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 13.475, s: [18, -112, 0], to: [9.367, 0, 0], ti: [-9.367, 0, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 16.081, s: [74.2, -112, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 23.903, s: [74.2, -112, 0], to: [9.3, 0, 0], ti: [-9.3, 0, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 26.512, s: [130, -112, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 29.118, s: [130, -112, 0], to: [0, 9.283, 0], ti: [0, -9.283, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 31.726, s: [130, -56.3, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 39.549, s: [130, -56.3, 0], to: [0, 9.317, 0], ti: [0, -9.317, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 42.155, s: [130, -0.4, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 47.37, s: [130, -0.4, 0], to: [0, 9.317, 0], ti: [0, -9.317, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 49.978, s: [130, 55.5, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 52.586, s: [130, 55.5, 0], to: [0, 9.35, 0], ti: [0, -9.35, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 55.192, s: [130, 111.6, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 57.8, s: [130, 111.6, 0], to: [-9.333, 0, 0], ti: [9.333, 0, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 60.407, s: [74, 111.6, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 65.622, s: [74, 111.6, 0], to: [-9.3, 0, 0], ti: [9.3, 0, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 68.229, s: [18.2, 111.6, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 70.837, s: [18.2, 111.6, 0], to: [0, -9.383, 0], ti: [0, 9.383, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 73.444, s: [18.2, 55.3, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 78.659, s: [18.2, 55.3, 0], to: [0, -9.183, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 81.267, s: [18.2, 0.2, 0], to: [0, 0, 0], ti: [-9.3, 0, 0] },
								{ t: 83.8740234375, s: [74, 0.2, 0] }
							],
							ix: 2
						},
						a: { a: 0, k: [424, 136, 0], ix: 1 },
						s: { a: 0, k: [100, 100, 100], ix: 6 }
					},
					ao: 0,
					ip: 0,
					op: 151,
					st: 7,
					bm: 0
				},
				{
					ddd: 0,
					ind: 10,
					ty: 2,
					nm: "Layer 9",
					parent: 5,
					refId: "image_8",
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: {
							a: 1,
							k: [
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.167, y: 0.167 }, t: 1.304, s: [18, -56, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 5, s: [18, -56, 0], to: [9.317, 0, 0], ti: [-9.317, 0, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 8.26, s: [73.9, -56, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 13.475, s: [73.9, -56, 0], to: [9.367, 0, 0], ti: [-9.367, 0, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 16.081, s: [130.1, -56, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 21.297, s: [130.1, -56, 0], to: [0, 9.317, 0], ti: [0, -9.317, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 23.903, s: [130.1, -0.1, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 29.118, s: [130.1, -0.1, 0], to: [0, 9.283, 0], ti: [0, -9.283, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 31.726, s: [130.1, 55.6, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 39.549, s: [130.1, 55.6, 0], to: [0, 9.317, 0], ti: [0, -9.317, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 42.155, s: [130.1, 111.5, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 47.37, s: [130.1, 111.5, 0], to: [0, 9.417, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 49.978, s: [130.1, 168, 0], to: [0, 0, 0], ti: [9.317, 0, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 52.586, s: [74.2, 168, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 57.8, s: [74.2, 168, 0], to: [-9.333, 0, 0], ti: [9.333, 0, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 60.407, s: [18.2, 168, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 63.015, s: [18.2, 168, 0], to: [0, -9.333, 0], ti: [0, 9.333, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 65.622, s: [18.2, 112, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 70.837, s: [18.2, 112, 0], to: [0, -9.383, 0], ti: [0, 9.383, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 73.444, s: [18.2, 55.7, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 76.052, s: [18.2, 55.7, 0], to: [9.317, 0, 0], ti: [-9.317, 0, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 78.659, s: [74.1, 55.7, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 81.267, s: [74.1, 55.7, 0], to: [9.3, 0, 0], ti: [-9.3, 0, 0] },
								{ t: 83.8740234375, s: [129.9, 55.7, 0] }
							],
							ix: 2
						},
						a: { a: 0, k: [424, 136, 0], ix: 1 },
						s: { a: 0, k: [100, 100, 100], ix: 6 }
					},
					ao: 0,
					ip: 0,
					op: 151,
					st: 5,
					bm: 0
				},
				{
					ddd: 0,
					ind: 11,
					ty: 2,
					nm: "Layer 8",
					parent: 5,
					refId: "image_9",
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: {
							a: 1,
							k: [
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.167, y: 0.167 }, t: 1.304, s: [18, -56, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 5, s: [18, -56, 0], to: [9.317, 0, 0], ti: [-9.317, 0, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 8.26, s: [73.9, -56, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 10.866, s: [73.9, -56, 0], to: [0, 9.317, 0], ti: [0, -9.317, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 13.475, s: [73.9, -0.1, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 21.297, s: [73.9, -0.1, 0], to: [0, 9.317, 0], ti: [0, -9.317, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 23.903, s: [73.9, 55.8, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 29.118, s: [73.9, 55.8, 0], to: [0, 9.283, 0], ti: [0, -9.283, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 31.726, s: [73.9, 111.5, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 39.549, s: [73.9, 111.5, 0], to: [0, 9.417, 0], ti: [0, -9.417, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 42.155, s: [73.9, 168, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 44.763, s: [73.9, 168, 0], to: [-9.333, 0, 0], ti: [9.333, 0, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 47.37, s: [17.9, 168, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 49.978, s: [17.9, 168, 0], to: [-9.317, 0, 0], ti: [9.317, 0, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 52.586, s: [-38, 168, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 55.192, s: [-38, 168, 0], to: [0, -9.283, 0], ti: [0, 9.283, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 57.8, s: [-38, 112.3, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 63.015, s: [-38, 112.3, 0], to: [0, -9.333, 0], ti: [0, 9.333, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 65.622, s: [-38, 56.3, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 70.837, s: [-38, 56.3, 0], to: [0, -9.383, 0], ti: [0, 9.383, 0] },
								{ t: 73.4443359375, s: [-38, 0, 0] }
							],
							ix: 2
						},
						a: { a: 0, k: [424, 136, 0], ix: 1 },
						s: { a: 0, k: [100, 100, 100], ix: 6 }
					},
					ao: 0,
					ip: 0,
					op: 151,
					st: 0,
					bm: 0
				},
				{
					ddd: 0,
					ind: 12,
					ty: 2,
					nm: "Layer 7",
					parent: 5,
					refId: "image_10",
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: {
							a: 1,
							k: [
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 1.304, s: [18, -56, 0], to: [0.033, 9.386, 0], ti: [-0.033, -9.386, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 5, s: [18.2, 0.317, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 6.304, s: [18.2, 0.317, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 10.866, s: [18.2, 0.317, 0], to: [0, 9.317, 0], ti: [0, -9.317, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 13.475, s: [18.2, 56.217, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 21.297, s: [18.2, 56.217, 0], to: [0, 9.317, 0], ti: [0, -9.317, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 23.903, s: [18.2, 112.117, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 29.118, s: [18.2, 112.117, 0], to: [0, 9.283, 0], ti: [0, -9.283, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 31.726, s: [18.2, 167.817, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 36.94, s: [18.2, 167.817, 0], to: [-9.35, 0, 0], ti: [9.35, 0, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 39.549, s: [-37.9, 167.817, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 44.763, s: [-37.9, 167.817, 0], to: [-9.333, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 47.37, s: [-93.9, 167.817, 0], to: [0, 0, 0], ti: [0, 9.3, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 49.978, s: [-93.9, 112.017, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 55.192, s: [-93.9, 112.017, 0], to: [0, -9.283, 0], ti: [0, 9.283, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 57.8, s: [-93.9, 56.317, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 63.015, s: [-93.9, 56.317, 0], to: [0, -9.333, 0], ti: [0, 9.333, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 65.622, s: [-93.9, 0.317, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 70.837, s: [-93.9, 0.317, 0], to: [0, -9.383, 0], ti: [0, 9.383, 0] },
								{ t: 73.4443359375, s: [-93.9, -55.983, 0] }
							],
							ix: 2
						},
						a: { a: 0, k: [424, 136, 0], ix: 1 },
						s: { a: 0, k: [100, 100, 100], ix: 6 }
					},
					ao: 0,
					ip: 0,
					op: 151,
					st: 0,
					bm: 0
				},
				{
					ddd: 0,
					ind: 13,
					ty: 2,
					nm: "Layer 12",
					parent: 5,
					refId: "image_11",
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: {
							a: 1,
							k: [
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 1.955, s: [18, -56, 0], to: [9.369, 0, 0], ti: [-9.369, 0, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 5.651, s: [74.217, -56, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 6.304, s: [74.217, -56, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 10.866, s: [74.217, -56, 0], to: [0, 9.317, 0], ti: [0, -9.317, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 13.475, s: [74.217, -0.1, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 21.297, s: [74.217, -0.1, 0], to: [0, 9.317, 0], ti: [0, -9.317, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 23.903, s: [74.217, 55.8, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 26.512, s: [74.217, 55.8, 0], to: [-9.3, 0, 0], ti: [9.3, 0, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 29.118, s: [18.417, 55.8, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 36.94, s: [18.417, 55.8, 0], to: [-9.35, 0, 0], ti: [9.35, 0, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 39.549, s: [-37.683, 55.8, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 42.155, s: [-37.683, 55.8, 0], to: [0, -9.333, 0], ti: [0, 9.333, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 44.763, s: [-37.683, -0.2, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 47.37, s: [-37.683, -0.2, 0], to: [0, -9.3, 0], ti: [0, 9.3, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 49.978, s: [-37.683, -56, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 55.192, s: [-37.683, -56, 0], to: [0, -9.283, 0], ti: [0, 9.283, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 57.8, s: [-37.683, -111.7, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 63.015, s: [-37.683, -111.7, 0], to: [0, -9.333, 0], ti: [0, 9.333, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 65.622, s: [-37.683, -167.7, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 68.229, s: [-37.683, -167.7, 0], to: [9.3, 0, 0], ti: [-9.3, 0, 0] },
								{ t: 70.8369140625, s: [18.117, -167.7, 0] }
							],
							ix: 2
						},
						a: { a: 0, k: [424, 136, 0], ix: 1 },
						s: { a: 0, k: [100, 100, 100], ix: 6 }
					},
					ao: 0,
					ip: 0,
					op: 151,
					st: 0,
					bm: 0
				},
				{
					ddd: 0,
					ind: 14,
					ty: 2,
					nm: "Layer 13",
					parent: 5,
					refId: "image_12",
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: {
							a: 1,
							k: [
								{ i: { x: 0.833, y: 0.833 }, o: { x: 0.333, y: 0 }, t: 0, s: [18, -56, 0], to: [0, 9.306, 0], ti: [0, -9.306, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.167, y: 0.167 }, t: 2.607, s: [18, -0.165, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 6.304, s: [18, -0.165, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 10.866, s: [18, -0.165, 0], to: [0, 9.317, 0], ti: [0, -9.317, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 13.475, s: [18, 55.735, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 18.688, s: [18, 55.735, 0], to: [-9.3, 0, 0], ti: [9.3, 0, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 21.297, s: [-37.8, 55.735, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 26.512, s: [-37.8, 55.735, 0], to: [-9.3, 0, 0], ti: [9.3, 0, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 29.118, s: [-93.6, 55.735, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 34.334, s: [-93.6, 55.735, 0], to: [0, -9.267, 0], ti: [0, 9.267, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 36.94, s: [-93.6, 0.135, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 42.155, s: [-93.6, 0.135, 0], to: [0, -9.333, 0], ti: [0, 9.333, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 44.763, s: [-93.6, -55.865, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 47.37, s: [-93.6, -55.865, 0], to: [0, -9.3, 0], ti: [0, 9.3, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 49.978, s: [-93.6, -111.665, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 55.192, s: [-93.6, -111.665, 0], to: [0, -9.283, 0], ti: [0, 9.283, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 57.8, s: [-93.6, -167.365, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 60.407, s: [-93.6, -168, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 61.06, s: [-93.6, -168, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 63.015, s: [-37.7, -168, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 68.229, s: [-37.7, -168, 0], to: [0, 0, 0], ti: [0, 0, 0] },
								{ t: 70.8369140625, s: [18.1, -168, 0] }
							],
							ix: 2
						},
						a: { a: 0, k: [424, 136, 0], ix: 1 },
						s: { a: 0, k: [100, 100, 100], ix: 6 }
					},
					ao: 0,
					ip: 0,
					op: 151,
					st: 0,
					bm: 0
				},
				{
					ddd: 0,
					ind: 15,
					ty: 2,
					nm: "Layer 1",
					parent: 5,
					refId: "image_13",
					sr: 1,
					ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [18, -56, 0], ix: 2 }, a: { a: 0, k: [424, 136, 0], ix: 1 }, s: { a: 0, k: [100, 100, 100], ix: 6 } },
					ao: 0,
					ip: 0,
					op: 151,
					st: 0,
					bm: 0
				}
			]
		}
	],
	layers: [
		{
			ddd: 0,
			ind: 1,
			ty: 0,
			nm: "FIXEL LOGO ANI_V02",
			refId: "comp_0",
			sr: 1,
			ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [540, 540, 0], ix: 2 }, a: { a: 0, k: [1024, 1024, 0], ix: 1 }, s: { a: 0, k: [52.734, 52.734, 100], ix: 6 } },
			ao: 0,
			tm: {
				a: 1,
				k: [
					{ i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [0] },
					{ i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 50, s: [3.56] },
					{ t: 111, s: [6] }
				],
				ix: 2
			},
			w: 2048,
			h: 2048,
			ip: 0,
			op: 151,
			st: 0,
			bm: 0
		}
	],
	markers: []
};
export default data;
